import {
    APP_TOKEN_LIST_REQUEST,
    APP_TOKEN_LIST_SUCCESS,
    APP_TOKEN_LIST_FAIL,
    APP_TOKEN_CREATE_REQUEST,
    APP_TOKEN_CREATE_SUCCESS,
    APP_TOKEN_CREATE_FAIL,
    APP_TOKEN_CREATE_RESET,
    APP_TOKEN_REVOKE_REQUEST,
    APP_TOKEN_REVOKE_SUCCESS,
    APP_TOKEN_REVOKE_FAIL,
    APP_TOKEN_REVOKE_RESET,
} from "../constants/AppTokenConstants";

export const appTokenListReducer = (state = { tokens: [] }, action) => {
    switch (action.type) {
        case APP_TOKEN_LIST_REQUEST:
            return { ...state, loading: true };
        case APP_TOKEN_LIST_SUCCESS:
            return { loading: false, tokens: action.payload };
        case APP_TOKEN_LIST_FAIL:
            return { loading: false, tokens: [], error: action.payload };
        default:
            return state;
    }
};

export const appTokenCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case APP_TOKEN_CREATE_REQUEST:
            return { loading: true };
        case APP_TOKEN_CREATE_SUCCESS:
            return { loading: false, success: true, createdToken: action.payload };
        case APP_TOKEN_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case APP_TOKEN_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const appTokenRevokeReducer = (state = {}, action) => {
    switch (action.type) {
        case APP_TOKEN_REVOKE_REQUEST:
            return { loading: true };
        case APP_TOKEN_REVOKE_SUCCESS:
            return { loading: false, success: true };
        case APP_TOKEN_REVOKE_FAIL:
            return { loading: false, error: action.payload };
        case APP_TOKEN_REVOKE_RESET:
            return {};
        default:
            return state;
    }
};
